import React from "react";

import CreativeViewPage from "../../../misc/pages/CreativeViewPage";

const TrainingCreativePage = () => <CreativeViewPage title="Training" />;

export default TrainingCreativePage;
